<div class="account_associator__wrapper">
    <element-autocomplete *ngIf=" authenticatedRole  == Role.Alpha" [data]="account_association_data" (onChange)="onChange($event)" placeholder="Enter name of {{account_association_role}}"></element-autocomplete>
    <element-table [table]="account_table" (onChange)="onTableChange($event)" [actions]="tableActions"></element-table>
</div>
